export const dc = "http://purl.org/dc/elements/1.1/";
export const dcterms = "http://purl.org/dc/terms/";
export const dctypes = "http://purl.org/dc/dcmitype/";
